import React from "react";
import styled from "styled-components";
import { hostOf, isDomainProperty } from "./siteOptions";

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

// The same favicon service Search Console's own property picker uses, so a property here looks like
// the one there. It fails quietly for a host that has no favicon or cannot be reached.
const Favicon = styled.img`
    width: 16px;
    height: 16px;
    flex: none;
`;

export const SiteFavicon = ({ siteUrl }) => (
    <Favicon
        src={`https://www.google.com/s2/favicons?sz=32&domain=${hostOf(siteUrl)}`}
        alt=""
        loading="lazy"
        onError={event => { event.target.style.visibility = "hidden"; }}
    />
);

// A domain property covers every subdomain and both schemes, a URL-prefix property only what is
// under it, so which one a property is decides what the figures will cover.
const Kind = styled.span`
    margin-left: auto;
    padding: 1px 6px;
    border-radius: 4px;
    background: #f1f5f9;
    color: #64748b;
    font-size: 0.7rem;
    white-space: nowrap;
`;

export const siteKind = siteUrl => isDomainProperty(siteUrl) ? "Domain" : "URL prefix";

// react-select re-renders every option in the menu each time the highlighted one changes, and the
// favicon is a remote image per row, so the menu carries none: the saved property shows one instead.
const SiteRow = React.memo(({ option }) => (
    <Row>
        {option.displayName}
        <Kind>{siteKind(option.value)}</Kind>
    </Row>
));

export const siteRow = option => <SiteRow option={option} />;

const GroupLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: none;
    font-size: 0.8rem;
    color: #0f172a;
`;

// One favicon per site instead of one per property: an account can reach hundreds of properties and
// each favicon is a request to Google, which is what made the open menu crawl.
export const groupRow = group => (
    <GroupLabel>
        <SiteFavicon siteUrl={group.options[0].value} />
        {group.label}
    </GroupLabel>
);
